module.exports = __webpack_public_path__ + "static/media/svg--logo.b19c54ff.svg";